/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import '@fullcalendar/common/main.css';
import '@fullcalendar/daygrid/main.css';
import { css } from '@emotion/react';
import { spacing } from '@mui/system';
import { Box, Card as MuiCard, CardContent as MuiCardContent } from '@mui/material';
import styled from '@emotion/styled';
/**
 * Styles for rate calendar are defined here
 */
export const calendarStyle = css`
  .fc-day-today {
    background: #ecf2fb !important;
    border: none !important;
  }
`;
//
export const FullCalendarWrapper = styled.div`
  ${calendarStyle}
`;
//
export const Card = styled(MuiCard)(spacing);
//
export const CardContent = styled(MuiCardContent)(spacing);
//
export const BoxIcon = styled(Box)`
  top: 214px;
  left: 2px;
  width: 8px;
  height: 8px;
  margin-left: 5px;
  opacity: 1;
  border-radius: 50%;
`;
